import React, { Component } from 'react';
import FakeData from '.././fake-data';
import ReactDOM from 'react-dom';
import { Link, Redirect } from 'react-router-dom';
import { Helmet } from "react-helmet";
import './TEAM.css';
import {
	BannerReportView
} from './Admin';
import { ChangePictureIcon, BannerShimmer, AngularTemplateView, EmptyState, LoadingState, PostItem, GlobalTMFeeds, GlobalTMForm, LeagueSplitView, SetTournGameModal, ItemPicker, Modal, ComboBox, PhotoAddModal, TagView, MomentPickerModal, EditGameModal, PlayOffView, FeedBackPopUp } from '.././components/Common';

import EventView from '.././components/Event';
import AboutView from '.././components/About';
import Photos from '.././components/Photos';
import Videos from '.././components/Videos';
import Games from '.././components/Games';
import Settings from '.././components/Settings';
import Squads from '.././components/Squads';
import Training from '.././components/Training';
import InternalNoticeCenter from '.././components/InternalNoticeCenter';
import ApplicationForm from '../components/ApplicationForm';

const Trojan = window.Trojan;
const Croppie = window.Croppie;
const $ = window.$;
const jQuery = window.jQuery;

class HomeView extends React.Component {
	constructor(props) {
		super(props)
		this.state = {
			id: this.props.match.params.teamId,
			team: { id: null },
			error: false,
			activeTab: 'squad',
			activeSquad: 0,
			tabs: this.props.withGuest ? [
				{ val: "about", key: "About", notices: [] },
				{ val: "apply", key: "Apply", notices: [] }
			] : [
					{ val: "timeline", key: "Timeline", notices: [] },
					{ val: "games", key: "Games", notices: [] },
					{ val: "about", key: "About", notices: [] },
					{ val: "apply", key: "Apply", notices: [] },
					{ val: "squad", key: "Squad", notices: [] },
					{ val: "photos", key: "Photos", notices: [] },
					{ val: "videos", key: "Videos", notices: [] },
					//        { val: "training", key: "Training", notices: [] },
					{ val: "events", key: "Events", notices: [] },
					{ val: "notice", key: "Notifications", notices: [] },
					{ val: "settings", key: "Settings", notices: [] }
				],
			offset: 0,
			posts: [],
			isLoadingPosts: true,
			events: [],
			yourPhotos: [],
			photosOfYou: [],
			albums: [],
			yourVideos: [],
			videosOfYou: [],
			limit: 30,
			seesions: [],
			seesionFiles: []
		}

		this.onScroll = this.onScroll.bind(this)
		this.setTab = this.setTab.bind(this)
		this.onPostAdded = this.onPostAdded.bind(this)
	}

	componentWillMount() {
		FakeData.mountState("team", true)
	}

	componentDidMount() {
		window.addEventListener('scroll', this.onScroll);
		const _that = this;
		const _type = "T"
		const _list = FakeData.getBlocked({ props: {} }, true, [_type]);
		const system = _list.BlockedBySystem.filter((item, i) => {
			return (item.username === this.props.match.params.id || item.user_id === this.props.match.params.id) && item.user_type === _type;
		})

		const by_you = _list.BlockedByYou.filter((item, i) => {
			return (item.username === this.props.match.params.id || item.user_id === this.props.match.params.id) && item.user_type === _type;
		})

		const for_you = _list.BlockedForYou.filter((item, i) => {
			return (item.username === this.props.match.params.id || item.user_id === this.props.match.params.id) && item.user_type === _type;
		})

		const final_array = system.concat(for_you, by_you);
		const username_array = [];
		final_array.forEach((item, i) => {
			username_array.push(item.username)
			username_array.push(item.user_id)
		})

		const _isBlocked = (FakeData.inArray(this.props.match.params.id, username_array)) ? true : false;
		if (_isBlocked) {
			_that.setState({
				error: true,
				user: { error: true }
			});
		} else {

			this.getProfile()
			//this.getPosts()
			this.getEvents()
			this.getStyle(this.props.match.params.id)
			//this.getSessions()
			document.querySelector("#root").addEventListener('scroll', this.onScroll);
			var params = FakeData.getQueries(this.props.location.search);
			this.setState({ activeTab: this.props.withGuest ? "about" : (params.sInit) ? params.sInit : "about", activeSquad: (params.squad_id) ? params.squad_id : 0 });
		}
	}

	shouldComponentUpdate(nextProps, nextState) {
		if (this.props.match.params.id !== nextProps.match.params.id || this.props.location.search !== nextProps.location.search) {
			const _that = this
			FakeData.mountState("team", false)
			this.setState({
				team: { id: null },
				id: nextProps.match.params.id
			});

			setTimeout((() => {
				FakeData.mountState("team", true)
				_that.getProfile()
				//_that.getPosts()
				_that.getEvents()
				_that.getStyle(nextProps.match.params.id)
				var params = FakeData.getQueries(_that.props.location.search);
				_that.setState({ activeTab: _that.props.withGuest ? "about" : (params.sInit) ? params.sInit : "about", activeSquad: (params.squad_id) ? params.squad_id : 0 });
			}), 1000)

			return true;
		}

		return true
	}

	componentWillUnmount() {
		FakeData.mountState("team", false)
		//window.removeEventListener('scroll', this.onScroll);

		document.querySelector("#root").removeEventListener('scroll', this.onScroll);
		const s = new Trojan.style("league").kill()
	}

	setTab(item) {
		this.setState({
			activeTab: item.val
		})
	}

	getStyle(id) {
		const _that = this
		if (!FakeData.isMounted("team")) {
			return
		}
		FakeData.post("/getTeamStyle.php?auth0", { teamId: id, table: "teams", field: "TeamID" }, {
			success: ((res) => {
				const style = res
				const s = new Trojan.style("league").declare(style).run()
				_that.getStyleID = setTimeout((() => {
					_that.getStyle(_that.props.match.params.id)
				}), 5000)
			}),
			error: ((err) => {
			})
		})
	}

	getProfile() {
		const _that = this
		let dataTo = {};
		if (_that.props.withGuest) {
			dataTo = {
				user: FakeData.guest,
				teamId: this.props.match.params.id,
				activeSquad: this.state.activeSquad
			}
		} else {
			dataTo = {
				user: FakeData.getData('yoo'),
				teamId: this.props.match.params.id,
				activeSquad: this.state.activeSquad
			}
		}
		if (!FakeData.isMounted("team")) {
			return
		}

		FakeData.post("/getTeamProfile.php?auth0", dataTo, {
			success: ((res) => {
				if (!FakeData.isMounted("team")) {
					return
				}

				if (res.error) {
					_that.setState({
						error: true,
						team: res
					});
				} else {
					if (!_that.props.withGuest) _that.state.tabs[8].notices = _that.getUnreadNotices(res.join_received)
					const _user = res;
					_user.type = "T"
					FakeData.setData("user", _user);
					var params = FakeData.getQueries(_that.props.location.search);
					_that.setState({
						team: res,
						tabs: _that.state.tabs,

					});
				}
				FakeData.setData("team", res)
				setTimeout((() => {
					_that.getProfile()
				}), 5000)
			}),
			error: ((err) => {
				_that.setState({
					error: true,
					team: { error: true }
				});
			})
		})
	}

	getPosts() {
		const _that = this
		const dataTo = {
			user: FakeData.getData("yoo"),
			userTo: {
				id: this.state.team.id,
				type: "T"
			},
			clubs: [],
			leagues: [],
			teams: [],
			limit: this.state.limit
		}

		if (!FakeData.isMounted("team")) {
			return
		}

		FakeData.post("/getPosts.php?auth0", dataTo, {
			success: ((res) => {
				if (!FakeData.isMounted("team")) {
					return
				}
				_that.setState({
					posts: res,
					isLoadingPosts: false
				})

				setTimeout((() => {
					_that.getPosts()
				}), 10000)
			}),
			error: ((err) => {

			})
		})
	}

	getEvents() {
		const _that = this
		const dataTo = {
			userId: FakeData.getData("yoo").id,
			userToId: this.props.match.params.id,
			userToType: "T",
			teamIds: this.props.match.params.id
		}

		if (!FakeData.isMounted("team")) {
			return
		}

		FakeData.post("/getEvents.php?auth0", dataTo, {
			success: ((res) => {
				if (!FakeData.isMounted("team")) {
					return
				}
				res.sort(function (a, b) {
					return b.timestamp - a.timestamp
				})
				_that.setState({
					events: res
				})

				setTimeout((() => {
					_that.getEvents()
				}), 10000)
			}),
			error: ((err) => {

			})
		})
	}

	onScroll(e) {
		this.setState({
			offset: document.querySelector("#root").scrollTop
		});
	}

	onPostAdded(post) {
		//console.log(this.state.posts.length);
		this.state.posts.unshift(post)
		this.setState({
			posts: this.state.posts
		});

		//console.log(this.state.posts.length);
	}

	getUnreadNotices = (notices) => {
		const list = []
		FakeData.listify(notices).forEach((item, i) => {
			if (item.context.status === "unread") {
				list.push(item)
			}
		})

		return list;
	}

	getSessions = () => {
		const _that = this
		const dataTo = {
			user: FakeData.getData("yoo"),
			userTo: {
				id: this.state.team.id,
				type: "T",
			}
		}

		FakeData.post("/getSessions.php?auth0", dataTo, {
			success: ((res) => {
				if (!FakeData.isMounted("team")) {
					return
				}
				_that.setState({
					sessions: res
				})

				setTimeout((() => {
					_that.getSessions()
				}), 15000)
			}),
			error: ((res) => {

			})
		})
	}

	render() {
		if (this.state.team.id == null && !this.state.team.error) {
			return (
				<BannerShimmer />
			);
		}

		if (this.state.team.error) {
			return (
				<Redirect to={{
					pathname: "/account_error",

				}} />
			)
		}

		const { withGuest, user } = this.props;

		if (withGuest) {
			return (
				<div className="tabs team row main_content sp-flex-width" style={{ zIndex: 0, padding: "10px 10px" }}>
					<Helmet
						title={this.state.team.name}
						meta={[
							{ "name": "description", "content": "Description of page" },
							{ property: "og:type", content: "profile" },
							{ property: "og:title", content: this.state.team.name },
							{ property: "og:image", content: this.state.team.image },
							{ property: "og:url", content: FakeData.baseURL + "/#" + this.props.location.pathname + this.props.location.search }
						]}
					/>
					<TeamBanner BlockedBySystem={this.props.BlockedBySystem} BlockedByYou={this.props.BlockedByYou} BlockedForYou={this.props.BlockedForYou} team={this.state.team} {...this.props} pictures={this.state.yourPhotos} activeTab={this.state.activeTab} tabs={this.state.tabs} onTabSelect={this.setTab} />
					{((this.state.activeTab != "training") && (this.state.activeTab != "events")) &&
						<LeagueSplitView BlockedBySystem={this.props.BlockedBySystem} BlockedByYou={this.props.BlockedByYou} BlockedForYou={this.props.BlockedForYou} class="league" profile={this.state.team} offset={this.state.offset}>
							{this.state.activeTab !== "apply" &&
								<div>
									<AboutView BlockedBySystem={this.props.BlockedBySystem} BlockedByYou={this.props.BlockedByYou} BlockedForYou={this.props.BlockedForYou} profile={this.state.team} type="T" hideTabs="true" state="team" />
								</div>
							}
							{this.state.activeTab == "apply" &&
								<ApplicationForm BlockedBySystem={this.props.BlockedBySystem} BlockedByYou={this.props.BlockedByYou} BlockedForYou={this.props.BlockedForYou} profile={FakeData.guest} {...this.props} withGuest={withGuest} isTeam={true} team={this.state.team} type={"T"} />
							}
						</LeagueSplitView>
					}
				</div>
			);
		}

		return (
			<div className="tabs team row main_content sp-flex-width" style={{ zIndex: 0, padding: "10px 10px" }}>
				<Helmet
					title={this.state.team.name}
					meta={[
						{ "name": "description", "content": "Description of page" },
						{ property: "og:type", content: "profile" },
						{ property: "og:title", content: this.state.team.name },
						{ property: "og:image", content: this.state.team.image },
						{ property: "og:url", content: FakeData.baseURL + "/#" + this.props.location.pathname + this.props.location.search }
					]}
				/>
				<TeamBanner BlockedBySystem={this.props.BlockedBySystem} BlockedByYou={this.props.BlockedByYou} BlockedForYou={this.props.BlockedForYou} team={this.state.team} pictures={this.state.yourPhotos} activeTab={this.state.activeTab} tabs={this.state.tabs} onTabSelect={this.setTab} />
				{((this.state.activeTab != "training") /*&& (this.state.activeTab != "events")*/) &&
					<LeagueSplitView BlockedBySystem={this.props.BlockedBySystem} BlockedByYou={this.props.BlockedByYou} BlockedForYou={this.props.BlockedForYou} class="league" profile={this.state.team} offset={this.state.offset}>
						{this.state.activeTab == "timeline" &&
							<div>
								<GlobalTMForm profile={this.state.team} words={() => {
									const _settings = FakeData.listify(this.state.team.settings).filter((set, i) => {
										return set.sub === "word_restrition"
									});

									if (_settings[0]) {
										return FakeData.nullify(_settings[0]['value']).split(",");
									} else {
										return []
									}
								}} isAdmin={this.state.team.isAdmin} onPostAdded={this.onPostAdded} postToType="T" postToId={this.state.team.id} postToName={this.state.team.name} postToImage={this.state.team.image} />
								<GlobalTMFeeds
									profile={this.state.team}
									postToType="T"
									words={() => {
										const _settings = FakeData.listify(this.state.team.settings).filter((set, i) => {
											return set.sub === "word_restrition"
										});

										if (_settings[0]) {
											return FakeData.nullify(_settings[0]['value']).split(",");
										} else {
											return []
										}
									}} page={{ id: this.state.team.id, type: "T" }} teams={[]} clubs={[]} leagues={[]} institutions={[]} user={(this.state.team.isAdmin) ? this.state.team : FakeData.getData("yoo")} userType={(this.state.team.isAdmin) ? "T" : "F"} posts={this.state.posts}>
									<EmptyState style={{ background: "#fff" }} isShown={(FakeData.listify(this.state.posts).length === 0 && !this.state.isLoadingPosts) ? true : false} text="No posts were found!" icon="filter_hdr" />
									<LoadingState style={{ background: "#fff" }} isShown={this.state.isLoadingPosts} text={"Loading"} />
								</GlobalTMFeeds>
							</div>
						}
						{this.state.activeTab == "games" &&
							<Games BlockedBySystem={this.props.BlockedBySystem} BlockedByYou={this.props.BlockedByYou} BlockedForYou={this.props.BlockedForYou} teams={[this.state.team.id]} league={false} />
						}
						{this.state.activeTab == "videos" &&
							<Videos BlockedBySystem={this.props.BlockedBySystem} BlockedByYou={this.props.BlockedByYou} BlockedForYou={this.props.BlockedForYou} user={(this.state.team) ? this.state.team : FakeData.getData("yoo")} userType={(this.state.team.isAdmin) ? "T" : "F"} author={this.state.team.name} data={{ uploads: this.state.yourVideos, tagged: this.state.videosOfYou }} isAdmin={this.state.team.isAdmin} />
						}
						{this.state.activeTab == "photos" &&
							<Photos BlockedBySystem={this.props.BlockedBySystem} BlockedByYou={this.props.BlockedByYou} BlockedForYou={this.props.BlockedForYou} user={(this.state.team) ? this.state.team : FakeData.getData("yoo")} userType={(this.state.team.isAdmin) ? "T" : "F"} author={this.state.team.name} data={{ uploads: this.state.yourPhotos, tagged: this.state.photosOfYou, albums: this.state.albums }} isAdmin={this.state.team.isAdmin} />
						}
						{this.state.activeTab == "about" &&
							<div>
								<AboutView BlockedBySystem={this.props.BlockedBySystem} BlockedByYou={this.props.BlockedByYou} BlockedForYou={this.props.BlockedForYou} profile={this.state.team} type="T" hideTabs="true" state="team" />
							</div>
						}
						{this.state.activeTab == "apply" &&
							<ApplicationForm BlockedBySystem={this.props.BlockedBySystem} BlockedByYou={this.props.BlockedByYou} BlockedForYou={this.props.BlockedForYou} profile={FakeData.getData("yoo")} {...this.props} isTeam={true} team={this.state.team} type={"T"} />
						}
						{this.state.activeTab == "settings" &&
							<Settings BlockedBySystem={this.props.BlockedBySystem} BlockedByYou={this.props.BlockedByYou} BlockedForYou={this.props.BlockedForYou} profile={this.state.team} settings={[
								"General",
								"Messaging",
								"Post Attribution",
								"Notifications",
								"Videos",
								"SPAM",
								"Page Roles"
							]} type="T" state="team" />
						}
						{this.state.activeTab == "notice" &&
							<InternalNoticeCenter BlockedBySystem={this.props.BlockedBySystem} BlockedByYou={this.props.BlockedByYou} BlockedForYou={this.props.BlockedForYou} notices={this.state.team.join_received} profile={this.state.team} type={"C"} />
						}
						{this.state.activeTab == "squad" &&
							<Squads BlockedBySystem={this.props.BlockedBySystem} BlockedByYou={this.props.BlockedByYou} BlockedForYou={this.props.BlockedForYou} contentId={this.state.team.id} content={this.state.team} contentType={"T"} sport={this.state.team.sport} squads={this.state.team.squads} isAdmin={this.state.team.isAdmin} />
						}
						{(this.state.activeTab == "events") &&
							<EventView BlockedBySystem={this.props.BlockedBySystem} BlockedByYou={this.props.BlockedByYou} BlockedForYou={this.props.BlockedForYou} viewEvents={true} eventToType="T" eventToID={this.state.team.id} events={this.state.events} profile={this.state.team} />
						}
					</LeagueSplitView>
				}

				{(this.state.activeTab == "training") &&
					<Training BlockedBySystem={this.props.BlockedBySystem} BlockedByYou={this.props.BlockedByYou} BlockedForYou={this.props.BlockedForYou} sessions={this.state.sessions} files={this.state.sessionFiles} user={this.state.team} userType={"T"} />
				}
			</div>
		);
	}
}

class TeamBanner extends React.Component {
	constructor(props) {
		super(props)
		this.state = {
			croppieEl: null,
			isCropping: false,
			croppie: {},
			isCroppingCover: false,
			img: this.props.team.cropped,
			originalImg: this.props.team.image
		}
	}

	componentWillReceiveProps(nextProps) {
		if (!this.state.isCropping || !this.state.isCroppingCover) {
			this.setState({ originalImg: nextProps.team.image, img: nextProps.team.cropped });
		}
	}

	componentWillMount() {
		const croppie = Croppie
	}

	setRef() {
		const _that = this
		this.setState({ isCropping: true })
		setTimeout(() => {
			const opts = {
				viewport: {
					width: 200,
					height: 200,
					type: 'circle'
				},
				enforceBoundary: false,
				boundary: {
					width: 300,
					height: 300
				}
			}

			const el = ReactDOM.findDOMNode(_that.el);
			const elem = $(el)[0];
			//console.log(elem);
			var c = new Croppie(elem, opts);

			c.bind({
				url: _that.state.originalImg
			})

			_that.croppie = c
		}, 500)
	}

	setRefCover() {
		const _that = this
		this.setState({ isCropping: true })
		setTimeout(() => {
			const opts = {
				viewport: {
					width: 420,
					height: 420,
				},
				enforceBoundary: false,
				boundary: {
					width: 420,
					height: 420
				}
			}

			const el = ReactDOM.findDOMNode(_that.elCover);
			const elem = $(el)[0];
			//console.log(elem);
			var c = new Croppie(elem, opts);

			c.bind({
				url: _that.state.originalImg
			})

			_that.croppieToo = c
		}, 500)
	}

	saveCrop() {
		const _that = this
		const opts = {
			type: "base64",
			format: "png",
			size: "original"
		}
		this.croppie.result(opts).then((res) => {
			_that.uploadCropped(res)
		}).catch((err) => {

		})
	}

	uploadCropped(data) {
		console.log("jkhjhj");
		const _that = this
		const dataTo = {
			data: data,
			id: this.props.team.id,
			table: "tourn"
		}

		FakeData.post("/uploadCroppedImg.php?auth0", dataTo, {
			success: ((res) => {
				if (!res.error) {
					_that.setState({
						img: data,
						isCropping: false
					});
				} else {
					_that.setState({
						img: _that.state.originalImg,
						isCropping: false
					});
				}


				_that.croppie.destroy()
			}),
			error: ((err) => {

			})
		})
	}

	getRGB(b) {
		var a;
		if (b && b.constructor == Array && b.length == 3) {
			return b;
		}

		if (a = /rgb\(\s*([0-9]{1,3})\s*,\s*([0-9]{1,3})\s*,\s*([0-9]{1,3})\s*\)/.exec(b)) {
			return [parseInt(a[1]), parseInt(a[2]), parseInt(a[3])];
		}

		if (a = /rgb\(\s*([0-9]+(?:\.[0-9]+)?)\%\s*,\s*([0-9]+(?:\.[0-9]+)?)\%\s*,\s*([0-9]+(?:\.[0-9]+)?)\%\s*\)/.exec(b)) {
			return [parseFloat(a[1]) * 2.55, parseFloat(a[2]) * 2.55, parseFloat(a[3]) * 2.55];
		}

		if (a = /#([a-fA-F0-9]{2})([a-fA-F0-9]{2})([a-fA-F0-9]{2})/.exec(b)) {
			return [parseInt(a[1], 16), parseInt(a[2], 16), parseInt(a[3], 16)];
		}

		if (a = /#([a-fA-F0-9])([a-fA-F0-9])([a-fA-F0-9])/.exec(b)) {
			return [parseInt(a[1] + a[1], 16), parseInt(a[2] + a[2], 16), parseInt(a[3] + a[3], 16)];
		}

		return (typeof (a) != "undefined") ? a[jQuery.trim(b).toLowerCase()] : null
	};

	luminance_get(color) {
		var rgb = this.getRGB(color);
		if (!rgb) {
			return null;
		}
		return 0.2126 * rgb[0] + 0.7152 * rgb[1] + 0.0722 * rgb[2];
	}

	getSelectedColor(color) {
		var val = (this.luminance_get(color) > 180) ? "#000" : "#fff"
		const dataTo = {
			bg: color,
			txt: val,
			id: this.props.team.id,
			table: "team"
		}

		const _that = this

		FakeData.post("/setColors.php?auth0", dataTo, {
			success: ((res) => {

			}),
			error: ((err) => {

			})
		})
	}

	getFilteredNotices = (arr, data) => {
		const list = [];
		FakeData.listify(data).forEach((item, i) => {
			if (FakeData.inArray(item.actionData.context, arr)) {
				list.push(item)
			}
		})

		return list
	}

	like() {
		const dataTo = {
			user: FakeData.getData("yoo"),
			type: "T",
			contentId: this.props.team.id,
			userOne: { id: this.props.team.id, type: "T" },
			userTwo: null,
			users: this.props.team.roles,
			userType: "F"
		}
		const _that = this

		FakeData.post('/likeContent.php?auth0', dataTo, {
			success: ((res) => {
				FakeData.alert("Done!");
			}),
			error: ((err) => {

			})
		}, true, "", () => { })
	}

	addToShortcuts() {
		const dataTo = {
			userId: FakeData.getData("yoo").id,
			contentType: "T",
			contentId: this.props.team.id,
			contentName: this.props.team.name,
			contentRef: this.props.team.id,
			contentSearch: "?sInit=about",
			userType: "F"
		}

		const _that = this

		FakeData.post('/createShortcut.php?auth0', dataTo, {
			success: ((res) => {
				FakeData.alert("Done!");
			}),
			error: ((err) => {

			})
		}, true, "", () => { })
	}

	render() {
		return (
			<div className="team-banner" style={{ width: FakeData.width, zIndex: 0, overflowY: 'hidden' }}>
				{this.props.team.isAdmin &&
					<BannerReportView id={this.props.team.id} type={'T'} />
				}
				{this.props.team.isAdmin &&
					<div className="team-banner-edit">
						{!this.state.isCropping && this.is &&
							<i className="material-icons" onClick={() => this.setRef()}>create</i>
						}
						{this.state.isCropping &&
							<i className="material-icons" onClick={() => this.setState({ isCropping: false })}>close</i>
						}
						{this.state.isCropping &&
							<i className="material-icons" onClick={() => this.saveCrop()}>save</i>
						}
						{!this.state.isCropping &&
							<i className="material-icons">format_color_fill<input onChange={(e) => this.getSelectedColor(e.target.value)} type="color" style={{ width: "12px", height: "12px", marginLeft: "-15px", opacity: 0 }} /></i>
						}
					</div>
				}
				<div className="team-banner-info" style={{ marginTop: ((this.props.team.isAdmin) ? "-16px" : "") }}>
					{this.state.isCropping &&
						<div ref={(c) => { this.el = c }} className="team-banner-info-logo">

						</div>
					}
					{!this.state.isCropping &&
						<div className="team-banner-info-logo">
							<img src={this.state.img} />
							{this.props.team.isAdmin &&
								<div className="front-photo">
									<ChangePictureIcon BlockedBySystem={this.props.BlockedBySystem} BlockedByYou={this.props.BlockedByYou} BlockedForYou={this.props.BlockedForYou} toType="T" pictures={this.props.pictures} type="DisplayPicture" idField={"TeamID"} table={"teams"} field={"DisplayPicture"} page="teams" toId={this.props.team.id} pictureForType="T" />
								</div>
							}
						</div>
					}
					<div className="team-banner-info-content">
						<h2>{this.props.team.name}</h2>
						<ul>
							{((this.props.team.website != null)) &&
								<li><img src={(this.props.team.color == "#fff") ? ".././images/website_icon_wht.svg" : ".././images/website_icon.svg"} /><span>{this.props.team.website}</span></li>
							}
							{((this.props.team.contactMain != null)) &&
								<li><img src={(this.props.team.color == "#fff") ? ".././images/mobile_icon_wht.svg" : ".././images/mobile_icon.svg"} /><span>{this.props.team.contactMain}</span></li>
							}
							{((this.props.team.email != null)) &&
								<li><img src={(this.props.team.color == "#fff") ? ".././images/email_icon_wht.svg" : ".././images/email_icon.svg"} /><span>{this.props.team.email}</span></li>
							}
							{((this.props.team.address != null)) &&
								<li><img src={(this.props.team.color == "#fff") ? ".././images/checkin_icon_wht.svg" : ".././images/checkin_gry.svg"} /><span>{this.props.team.address}</span></li>
							}
						</ul>
						{!this.props.withGuest &&
							<div className="action-buttons">
								{(!this.props.team.hasShortcut && this.props.team.isAdmin) && <div onClick={this.addToShortcuts.bind(this)}><i className="material-icons">add</i>Add to shortcuts</div>}
								{!this.props.team.isLiked && <div onClick={this.like.bind(this)}><i className="material-icons">thumb_up</i>Like</div>}
								{this.props.team.isLiked && <div onClick={this.like.bind(this)}><i className="material-icons">thumb_down</i>Unlike</div>}
								{!this.props.team.isFollewed && <div onClick={() => { }}><i className="material-icons">turned_in</i>Follow</div>}
								{this.props.team.isFollewed && <div onClick={() => { }}><i className="material-icons">turned_in_not</i>Unfollow</div>}
								{!this.props.team.isAdmin &&
									<div onClick={() => {
										const chat = this.props.team.convo ? this.props.team.convo : {
											otherUser: {
												id: this.props.team.id,
												type: "T",
												...this.props.team
											},
											id: null,
											userOne: FakeData.getData("yoo"),
											userTwo: {
												id: this.props.team.id,
												type: "T",
												...this.props.team
											},
											messages: [],
											last_msg: null,
											unread: 0,
											isYou: true,
											date: null,
											removedByUserOne: false,
											removedByUserTwo: false,
											type: "timeline",
											target: "new"
										}

										FakeData.shared("mainThread").addToChats(chat)
									}}><i className="material-icons">chat</i>Message</div>


								}
								<div>
									<FeedBackPopUp isBanner={true} userTo={{
										id: FakeData.getData("yoo").id,
										type: "F"
									}} user={{
										id: this.props.team.id,
										type: "T"
									}} object={{
										id: this.props.team.id,
										type: "T",
										content: this.props.team.name,
										image: this.props.team.image
									}} owner={{
										id: this.props.team.id,
										type: "T",
										name: this.props.team.name,
										user: this.props.team.username,
										image: this.props.team.image,
										email: this.props.team.email,
										roles: this.props.team.roles
									}} text={"More"} iconStyle={{
										margin: "0px 0px 0px 10px",
									}} icon={"more_horiz"} style={{
										display: 'flex'
									}} menus={this.props.team.isAdmin ? {
										Setting: {
											label: "Timeline Settings", cb: () => {
												this.props.onTabSelect(
													{ val: "settings", key: "Settings", notices: [] }
												);
											}
										}
									} : {
											FeedBack: { label: "Report Profile", cb: () => { } },
											Block: { label: "Block", cb: () => { } }
										}} />
								</div>
							</div>
						}
					</div>
					<div className="team-banner-info-cover">
						<img src={this.state.originalImg} />
						{this.props.team.isAdmin && this.is &&
							<i className="material-icons" style={{ marginRight: "60px", fontSize: "15px" }} onClick={() => this.setState({ isCroppingCover: true })}>edit</i>
						}
						{this.props.team.isAdmin &&
							<div className="back-photo">
								<ChangePictureIcon toType="T" pictures={this.props.pictures} type="CoverPicture" idField={"TeamID"} table={"teams"} field={"CoverPicture"} page="teams" toId={this.props.team.id} pictureForType="T" />
							</div>
						}
					</div>

				</div>
				<div className="team-banner-nav">
					{
						this.props.tabs.map((item, i) => {
							if (FakeData.inArray(item.val, ["notice", "training", "events", "settings"]) && !this.props.team.isAdmin) {
								return null;
							}

							return (
								<div className={(this.props.activeTab == item.val) ? "active" : ""} key={i} onClick={() => this.props.onTabSelect(item)}>
									{item.key}
									{(item.notices.length > 0 && this.props.team.isAdmin) &&
										<div className="notices-badge">
											{this.getFilteredNotices(["event_invite", "event_admin_invite", "event_accept"], item.notices).length > 0 &&
												<span className="events">{this.getFilteredNotices(["event_invite", "event_admin_invite", "event_accept"], item.notices).length}</span>
											}
											{this.getFilteredNotices([], item.notices).length > 0 &&
												<span className="_training">{this.getFilteredNotices([], item.notices).length}</span>
											}
											{this.getFilteredNotices(["game_invite", "game_accept"], item.notices).length > 0 &&
												<span className="games">{this.getFilteredNotices(["game_invite", "game_accept"], item.notices).length}</span>
											}
											<span className="all">{item.notices.length}</span>
										</div>
									}
								</div>
							)
						})
					}
				</div>
			</div>
		);
	}
}

export default HomeView;


// WEBPACK FOOTER //
// ./src/pages/TEAM.js